export default function WhyUsersSection() {
  const cards = [
    {
      icon: 'ri-database-2-line',
      img: 'https://readdy.ai/api/search-image?query=Organized%20product%20catalog%20grid%20display%20with%20fashion%20items%20including%20sneakers%20hoodies%20and%20accessories%20neatly%20arranged%20on%20minimalist%20white%20shelves%2C%20soft%20natural%20daylight%20from%20large%20windows%2C%20clean%20modern%20retail%20aesthetic%2C%20warm%20cream%20and%20beige%20neutral%20tones%2C%20editorial%20product%20photography%2C%20shallow%20depth%20of%20field%2C%20luxurious%20texture%20details&width=800&height=500&seq=why-finds-v2&orientation=landscape',
      title: 'Basetao Finds Database',
      desc: 'Discover organized product recommendations across every category — from sneakers and hoodies to accessories and electronics.',
      color: 'primary',
    },
    {
      icon: 'ri-ship-line',
      img: 'https://readdy.ai/api/search-image?query=International%20shipping%20parcels%20and%20cardboard%20boxes%20stacked%20neatly%20on%20wooden%20pallet%20with%20shipping%20labels%20and%20tracking%20barcodes%20visible%2C%20organized%20package%20station%20setting%2C%20warm%20natural%20light%20streaming%20through%20industrial%20windows%2C%20clean%20minimal%20composition%2C%20neutral%20cream%20and%20kraft%20paper%20tones%2C%20professional%20logistics%20photography%2C%20soft%20shadows&width=800&height=500&seq=why-shipping-v2&orientation=landscape',
      title: 'Basetao Shipping Guide',
      desc: 'Understand every shipping method, estimated delivery times, and detailed cost breakdowns by destination country.',
      color: 'accent',
    },
    {
      icon: 'ri-star-line',
      img: 'https://readdy.ai/api/search-image?query=Open%20laptop%20displaying%20product%20review%20interface%20with%20five%20star%20ratings%20and%20customer%20testimonials%2C%20cozy%20modern%20workspace%20with%20warm%20ambient%20desk%20lamp%20light%2C%20coffee%20cup%20and%20notebook%20nearby%2C%20minimalist%20desk%20setup%2C%20cream%20and%20warm%20beige%20tones%2C%20professional%20editorial%20tech%20photography%2C%20soft%20bokeh%20background&width=800&height=500&seq=why-reviews-v2&orientation=landscape',
      title: 'Basetao Reviews & Experiences',
      desc: 'Learn the real advantages and disadvantages from actual users who have completed hundreds of orders.',
      color: 'secondary',
    },
    {
      icon: 'ri-store-2-line',
      img: 'https://readdy.ai/api/search-image?query=Organized%20modern%20warehouse%20storage%20facility%20with%20neatly%20arranged%20parcels%20and%20boxes%20on%20metal%20shelving%20units%2C%20clean%20logistics%20center%20interior%2C%20soft%20industrial%20LED%20lighting%2C%20warm%20neutral%20cream%20and%20grey%20tones%2C%20professional%20storage%20facility%20photography%2C%20organized%20efficient%20layout%2C%20shallow%20depth%20of%20field&width=800&height=500&seq=why-warehouse-v2&orientation=landscape',
      title: 'Basetao Warehouse Guide',
      desc: 'Understand how storage works, parcel consolidation, QC photo requests, and managing your items before shipping.',
      color: 'primary',
    },
  ];

  const colorMap: Record<string, { bg: string; text: string; hoverBg: string; hoverText: string }> = {
    primary: { bg: 'bg-primary-100', text: 'text-primary-600', hoverBg: 'group-hover:bg-primary-500', hoverText: 'group-hover:text-background-50' },
    accent: { bg: 'bg-accent-100', text: 'text-accent-600', hoverBg: 'group-hover:bg-accent-500', hoverText: 'group-hover:text-background-50' },
    secondary: { bg: 'bg-secondary-100', text: 'text-secondary-600', hoverBg: 'group-hover:bg-secondary-500', hoverText: 'group-hover:text-background-50' },
  };

  return (
    <section id="why-users" className="py-16 md:py-24 px-4 md:px-6 bg-background-100">
      <div className="max-w-6xl mx-auto">
        <div className="text-center mb-12 md:mb-16">
          <span className="inline-block px-4 py-1.5 rounded-full bg-accent-100 text-accent-800 text-xs font-semibold tracking-wide uppercase mb-4">
            Why Basetao Sheet
          </span>
          <h2 className="font-heading text-3xl md:text-4xl font-bold text-foreground-950 mb-4">
            Why Thousands Search for <span className="italic text-accent-600">Basetao Spreadsheet</span>
          </h2>
          <p className="text-foreground-600 max-w-2xl mx-auto text-base leading-relaxed">
            Every day, shoppers around the world turn to Basetao Spreadsheet resources to make smarter purchasing decisions. Here is what you will find inside.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
          {cards.map((card) => {
            const c = colorMap[card.color];
            return (
              <div
                key={card.title}
                className="group bg-background-50 rounded-xl overflow-hidden border border-background-200/60 hover:border-accent-200/40 transition-all duration-300"
              >
                <div className="relative w-full h-48 overflow-hidden">
                  <img
                    src={card.img}
                    alt={card.title}
                    className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-background-50/40 via-transparent to-transparent"></div>
                </div>
                <div className="p-5 md:p-6 flex gap-4">
                  <div className={`w-11 h-11 flex-shrink-0 flex items-center justify-center rounded-xl ${c.bg} ${c.text} ${c.hoverBg} ${c.hoverText} transition-all duration-300`}>
                    <i className={`${card.icon} text-lg`}></i>
                  </div>
                  <div>
                    <h3 className="font-heading text-lg font-semibold text-foreground-900 mb-2">{card.title}</h3>
                    <p className="text-foreground-600 text-sm leading-relaxed">{card.desc}</p>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}